import { AppConfig } from '@aipb/env/util';
import { FacetsLimits } from '../model';
import { MercEnv } from './merc.env';

export class MercConfig extends AppConfig<MercEnv> {
  get europeanaApiKey(): string {
    return this.config.europeanaApiKey;
  }

  get detailUrl(): string {
    return this.config.detailUrl;
  }

  get mineUrl(): string {
    return this.config.mineUrl;
  }

  get facetsLimits(): FacetsLimits {
    return (
      this.config.facetsLimits || {
        YEAR: 2022,
        PROVIDER: 10
      }
    );
  }
}
